import { apiSlice } from "../../app/api/apiSlice";

export const attachEnhancedConditionDocumentToUploadUrlApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
			attachEnhancedConditionDocumenToUploadUrl: builder.mutation({
			query: ({
				uploadUrl,
				authorization,
				file,
				meta,
				user_email,
				loanGuid,
				conditionId,
				conditionName,
				entityId,
				entityType,
				title,
				loanType,
			}) => {
				const formData = new FormData();
				formData.append("uploadUrl", uploadUrl);

				if (authorization) {
					formData.append("authorization", authorization);
				}

				const normalizedUserEmail = String(user_email ?? "").trim();
				if (normalizedUserEmail) {
					formData.append("user_email", normalizedUserEmail);
				}

				// Retry-record context: only needed so the backend can persist a
				// retry row and resume this upload later if Encompass returns 409.
				if (loanGuid) formData.append("loanGuid", loanGuid);
				if (conditionId) formData.append("conditionId", conditionId);
				if (conditionName) formData.append("conditionName", conditionName);
				if (entityId) formData.append("entityId", entityId);
				if (entityType) formData.append("entityType", entityType);
				if (title) formData.append("title", title);
				if (loanType) formData.append("loanType", loanType);

				formData.append(
					"file",
					file,
					meta?.chunkName || file?.name || "upload-file"
				);

				if (meta?.isChunked) {
					formData.append("chunk_index", String(meta?.chunkIndex));
					formData.append("total_chunks", String(meta?.totalChunks));
					formData.append("chunk_size", String(meta?.chunkSize));
					formData.append("upload_id", meta?.uploadId);
					formData.append("original_file_name", meta?.originalFileName);
					formData.append("original_file_size", String(meta?.originalFileSize));
					formData.append("is_chunked", "true");
					formData.append("is_first_chunk", String(meta?.isFirstChunk));
					formData.append("is_last_chunk", String(meta?.isLastChunk));
				}

				return {
					url: `/api/v1/loan/enhanced_condition_upload_file_to_upload_url/`,
					method: "POST",
					body: formData,
				};
			},
		}),
	}),
});

export const {
	useAttachEnhancedConditionDocumenToUploadUrlMutation: useAttachEnhancedConditionDocumentToUploadUrlMutation,
} = attachEnhancedConditionDocumentToUploadUrlApiSlice;
